import React, { useEffect, useState } from 'react';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { Form, reduxForm } from 'redux-form';
import { actionTypeEnum, FORM_LOGIN_NAME } from '../../consts';
import Button from '../../../../components/Button';
import PaddingBox from '../../../../components/PaddingBox';
import CloakLoading from '../../../../components/CloakLoading';
import FlexGrid, { FlexGridColumn } from '../../../../components/FlexGrid';
import AuthenticationTitle from '../AuthenticationTitle';
import AuthenticationLoginForm from '../AuthenticationLoginForm';
import AuthenticationActionButton from '../AuthenticationActionButton';
import AuthenticationErrorsBox from '../AuthenticationErrorsBox';
import AuthenticationLoginController from './decorators/authenticationLoginController';
import AuthenticationContextConnect from '../../decorators/authenticationContextConnect';
import { compose } from 'redux';
import { codes } from '../../../../data/translations';
import AuthenticationBackButton from '../AuthenticationBackButton';
import { mapState } from './authenticationLoginMapState';
import { useTranslationAPI } from '../../../translations';
import { ReCaptcha } from '../../../../@packages/reCaptcha';

const LoadableAuthenticationLoginSelectOrganization = Loadable({
	loader: () => import('../AuthenticationLoginSelectOrganization'),
	loading: () => <CloakLoading />,
});

const AuthenticationLoginComponent = ({
	handleSubmit,
	handleFormSubmit,
	isLoginPending,
	handleADFSLogin,
	handleAzureAdLogin,
	authenticationInitialData,
	actionType,
	metadata,
	errors,
	authenticationSetActionType,
	portalData,
	formValues,
	setPreviewLoginFormEmail,
	valid,
	submit,
	change,
}) => {
	const [hasRecaptcha, setHasRecaptcha] = useState(false);
	const { translate } = useTranslationAPI();

	let errorsList = null;

	if (errors && errors._) {
		errorsList = {
			...errors._,
		};
	}

	if (portalData && portalData.errors && portalData.errors._) {
		errorsList = {
			...errorsList,
			...portalData.errors._,
		};
	}

	const isReCaptchaRequired = Boolean(errors?._?.wrongLogIn?.reCaptchaRequired === 'True');

	const handleReCaptchaVerifySuccess = async (token) => {
		await change('recaptchaResponse', token);
		submit();
	};

	useEffect(() => {
		if (isReCaptchaRequired) {
			setHasRecaptcha(isReCaptchaRequired);
		}
	}, [isReCaptchaRequired]);

	return (
		<>
			<AuthenticationTitle>
				{actionType === actionTypeEnum.MULTIPLE_ORGANIZATION_CONFLICT && (
					<AuthenticationBackButton
						onClick={() => {
							authenticationSetActionType(actionTypeEnum.LOGIN_FORM);
						}}
					/>
				)}
				{translate(codes.user.login)}
			</AuthenticationTitle>
			{errorsList && <AuthenticationErrorsBox errors={errorsList} />}
			<Form onSubmit={handleSubmit(handleFormSubmit)}>
				{(actionType === actionTypeEnum.LOGIN_FORM || actionType === actionTypeEnum.LOGIN_FORM_GET) && (
					<AuthenticationLoginForm
						authenticationSetActionType={authenticationSetActionType}
						translate={translate}
						saveEmail={setPreviewLoginFormEmail}
						formValues={formValues}
						disabled={isLoginPending}
					/>
				)}
				{actionType === actionTypeEnum.MULTIPLE_ORGANIZATION_CONFLICT && (
					<LoadableAuthenticationLoginSelectOrganization
						metadata={metadata}
						translate={translate}
					/>
				)}
				<PaddingBox
					topSmall
					bottomTiny
				>
					{hasRecaptcha ? (
						<ReCaptcha
							sitekey={authenticationInitialData.recaptchaPublicKey}
							onVerifySuccess={handleReCaptchaVerifySuccess}
						>
							{(captcha) => {
								return (
									<Button
										type='button'
										onClick={valid ? captcha.execute : submit}
										primary
										block
										size='small'
										disabled={isLoginPending}
									>
										{translate(codes.user.login)}
									</Button>
								);
							}}
						</ReCaptcha>
					) : (
						<Button
							type='submit'
							primary
							block
							size='small'
							disabled={isLoginPending}
						>
							{translate(codes.user.login)}
						</Button>
					)}
				</PaddingBox>
			</Form>
			{authenticationInitialData.hasAdfs && (
				<PaddingBox topTiny>
					<FlexGrid hrCenter>
						<FlexGridColumn>
							<AuthenticationActionButton
								styleType='primary'
								onClick={handleADFSLogin}
							>
								{translate(codes.user.logInWithADFS)}
							</AuthenticationActionButton>
						</FlexGridColumn>
					</FlexGrid>
				</PaddingBox>
			)}
			{authenticationInitialData.hasAzureAd && (
				<PaddingBox topTiny>
					<FlexGrid hrCenter>
						<FlexGridColumn>
							<AuthenticationActionButton
								styleType='primary'
								onClick={handleAzureAdLogin}
							>
								{translate(codes.user.authenticateWithAzureAd)}
							</AuthenticationActionButton>
						</FlexGridColumn>
					</FlexGrid>
				</PaddingBox>
			)}
		</>
	);
};

export const AuthenticationLogin = compose(
	connect(mapState),
	reduxForm({
		form: FORM_LOGIN_NAME,
		touchOnBlur: false,
	}),
	AuthenticationContextConnect,
	AuthenticationLoginController,
)(AuthenticationLoginComponent);
